export const USER_ROLES = ['admin', 'manager', 'billing', 'purchaseOrderOperator'] as const

export type UserRole = (typeof USER_ROLES)[number]

export const isUserRole = (role: string): role is UserRole => USER_ROLES.some((item) => item === role)
